import { useEffect, useRef } from 'react';

export default function AboutModal({ onClose }: { onClose: () => void }) {
  const closeRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    closeRef.current?.focus();
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div className="backdrop" onClick={onClose}>
      <div
        className="modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="about-modal-title"
        onClick={(e) => e.stopPropagation()}
        style={{ maxWidth: '640px' }}
      >
        <button
          ref={closeRef}
          className="close"
          onClick={onClose}
          aria-label="Close modal"
        >
          ×
        </button>

        <header className="head">
          <span className="kindTag">Guide & Inquiry</span>
          <h2 id="about-modal-title" style={{ fontSize: '1.4rem', marginTop: '4px' }}>
            About StokApp & How to Try
          </h2>
        </header>

        <div className="prose" style={{ marginTop: '16px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
          
          {/* Section 1: What is it */}
          <div style={{ background: 'var(--panel-bg, rgba(255,255,255,0.03))', padding: '16px', borderRadius: '12px', border: '1px solid rgba(255,255,255,0.08)' }}>
            <h3 style={{ margin: '0 0 8px 0', fontSize: '1rem', color: '#fff' }}>💡 What is StokApp?</h3>
            <p style={{ margin: 0, fontSize: '0.85rem', lineHeight: '1.5', color: '#cbd5e1' }}>
              StokApp is a Mac desktop application for tracking a personal investment portfolio against rules you define. 
              This web app is an interactive, browser-based demonstration of the actual line-for-line decision engine.
            </p>
          </div>

          {/* Section 2: How to use */}
          <div style={{ background: 'var(--panel-bg, rgba(255,255,255,0.03))', padding: '16px', borderRadius: '12px', border: '1px solid rgba(255,255,255,0.08)' }}>
            <h3 style={{ margin: '0 0 10px 0', fontSize: '1rem', color: '#fff' }}>🎮 How to Try & Test</h3>
            <ul style={{ margin: 0, paddingLeft: '20px', fontSize: '0.85rem', lineHeight: '1.6', color: '#cbd5e1' }}>
              <li><strong>Adjust Rule Sliders:</strong> Move the <em>Near 52-week low</em> or <em>Dividend yield</em> sliders to watch stock badges update in real time.</li>
              <li><strong>Switch Screens:</strong> Toggle between <strong>Today</strong> (all instruments), <strong>Portfolio</strong> (held positions), and <strong>Watchlist</strong> (rule breakdowns).</li>
              <li><strong>View Deep Dives:</strong> Click on any stock row to open its pre-baked multi-lens analysis report.</li>
            </ul>
          </div>

          {/* Section 3: Contact for full app */}
          <div style={{ background: 'rgba(99, 102, 241, 0.08)', padding: '16px', borderRadius: '12px', border: '1px solid rgba(99, 102, 241, 0.3)' }}>
            <h3 style={{ margin: '0 0 6px 0', fontSize: '1rem', color: '#818cf8' }}>✉️ Request Full App & Custom Engines</h3>
            <p style={{ margin: '0 0 12px 0', fontSize: '0.85rem', lineHeight: '1.5', color: '#cbd5e1' }}>
              Interested in obtaining the full desktop Mac app, customized rule engines, or consulting on system automation by <strong>Yarnin Peled</strong>?
            </p>

            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
              <a
                href="mailto:yarninp@gmail.com?subject=StokApp%20Full%20App%20Inquiry"
                style={{
                  background: '#4f46e5',
                  color: '#fff',
                  padding: '8px 14px',
                  borderRadius: '8px',
                  fontSize: '0.8rem',
                  fontWeight: 'bold',
                  textDecoration: 'none',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px'
                }}
              >
                <span>✉️ Email Yarnin</span>
              </a>

              <a
                href="tel:+972547918818"
                style={{
                  background: 'rgba(255,255,255,0.1)',
                  color: '#fff',
                  padding: '8px 14px',
                  borderRadius: '8px',
                  fontSize: '0.8rem',
                  fontWeight: 'bold',
                  textDecoration: 'none',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px'
                }}
                title="Call Yarnin"
              >
                <span>📞 Call Yarnin</span>
              </a>

              <a
                href="https://ponyapp.net/contact"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  background: 'rgba(255,255,255,0.1)',
                  color: '#818cf8',
                  padding: '8px 14px',
                  borderRadius: '8px',
                  fontSize: '0.8rem',
                  fontWeight: 'bold',
                  textDecoration: 'none',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px'
                }}
              >
                <span>🌐 ponyapp.net/contact</span>
              </a>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}
